export default "__VITE_ASSET__DYmsyvCS__"